import(/* webpackMode: "eager", webpackExports: ["ClientDatesProvider"] */ "/usr/src/app/components/ClientDatesProvider/ClientDatesProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyAppShell"] */ "/usr/src/app/components/MyAppShell/MyAppShell.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@mantine/charts/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["ColorSchemeScript"] */ "/usr/src/app/node_modules/@mantine/core/esm/core/MantineProvider/ColorSchemeScript/ColorSchemeScript.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/usr/src/app/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@mantine/dates/styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@mantine/dropzone/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["closeAllModals","closeModal","modals","openConfirmModal","openContextModal","openModal","updateContextModal","updateModal"] */ "/usr/src/app/node_modules/@mantine/modals/esm/events.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ModalsProvider"] */ "/usr/src/app/node_modules/@mantine/modals/esm/ModalsProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useModals"] */ "/usr/src/app/node_modules/@mantine/modals/esm/use-modals/use-modals.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Notifications"] */ "/usr/src/app/node_modules/@mantine/notifications/esm/Notifications.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["cleanNotifications","cleanNotificationsQueue","createNotificationsStore","hideNotification","notifications","notificationsStore","showNotification","updateNotification","updateNotificationsState","useNotifications"] */ "/usr/src/app/node_modules/@mantine/notifications/esm/notifications.store.mjs");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@mantine/notifications/styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/mantine-react-table/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/usr/src/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-nunito\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/providers/QueryClientContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/usr/src/app/theme.ts");
